module.exports = __webpack_public_path__ + "img/Journalism03.0163e378.png";